// extracted by mini-css-extract-plugin
export default {"cls1":"lgzurob9gevpKDqoa2hF","cls2":"QOU3QpSrHPrQccPLlka5 lgzurob9gevpKDqoa2hF"};